// ENUMS #############################################################
export enum PositionEnum {
	LEFT = 'left',
	RIGHT = 'right',
}


// INTERFACES ########################################################
export interface IPreselectedDateItem {
	id: string;
	date: Date;
	label: string;
	disabled: boolean;
	isActive: boolean;
}

export interface IYearListItem {
	year: number;
	disabled: boolean;
}
